import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import {
  DashboardResponse,
  OauthAEMConfig,
  UserSessionService
} from '@com-delta-idp/mnx-oauth';
import {
  ApiBuilder,
  AppConfigService,
  HttpHeadersPayload,
  HttpRequestMethods,
  handleError
} from '@com-delta-idp/mnx-utils';
import { Observable } from 'rxjs';
import { share } from 'rxjs/operators';
import {
  DashboardDataResponse,
  loginAndGetDashboardRequest,
  loginAndGetDashboardResponse,
  loginCustomerRequest,
  loginCustomerResponse,
  loginQueryParam
} from '../models/login-authentication-screen.interface';
import { LoginModalEndpointsKeys } from '../models/login-modal.enum';

@Injectable({
  providedIn: 'root'
})
export class LoginDasboardService {
  getLoginResponseValues: Observable<DashboardResponse> | undefined;
  getLoginResponseValuesCust: Observable<DashboardDataResponse> | undefined;
  protected http = inject(HttpClient);
  protected appConfig = inject(AppConfigService);
  protected userSessionService = inject(UserSessionService);
  errorHandler = handleError.bind(this);

  getDashBrdDataCust = (): Observable<DashboardDataResponse> =>
    new ApiBuilder<Record<string, string | number>, DashboardDataResponse>(
      this.http,
      this.appConfig
    )
      .app('COMMON')
      .endpointKey(LoginModalEndpointsKeys['DASHBOARD_BFF_URL'])
      .method(HttpRequestMethods['POST'])
      .payload({})
      .errorHandler(this.errorHandler)
      .library('LOGIN_DASHBOARD_SERVICE')
      .create();

  getLoginResponse(): Observable<DashboardResponse> {
    if (this.getLoginResponseValues) {
      return this.getLoginResponseValues;
    } else {
      this.getLoginResponseValues = this.userSessionService
        .getUserSession()
        .pipe(share());
      return this.getLoginResponseValues;
    }
  }

  getVsDashboardResponse(): Observable<Partial<DashboardDataResponse>> {
    if (this.getLoginResponseValuesCust) {
      return this.getLoginResponseValuesCust;
    } else {
      this.getLoginResponseValuesCust = this.getDashBrdDataCust().pipe(share());
      return this.getLoginResponseValuesCust;
    }
  }

  getDashBrdData = (
    authenticationConfig: OauthAEMConfig,
    payload: loginAndGetDashboardRequest,
    tokenResponse?: string
  ): Observable<loginAndGetDashboardResponse> => {
    const headers: HttpHeadersPayload = {
      'Content-Type': 'application/json'
    };
    if (tokenResponse) {
      headers['Authorization'] = 'Bearer ' + tokenResponse;
    }
    return new ApiBuilder<
      loginAndGetDashboardRequest,
      loginAndGetDashboardResponse
    >(this.http, this.appConfig)
      .app('LOGIN_MODAL')
      .endpointKey(LoginModalEndpointsKeys['LOGIN_DASHBOARD_BFF_URL'])
      .method(HttpRequestMethods['POST'])
      .payload(payload)
      .httpHeaders(headers)
      .timeOut(authenticationConfig.LOGIN_TIMEOUT ?? 10000)
      .errorHandler(this.errorHandler)
      .library('LOGIN_DASHBOARD_SERVICE')
      .create();
  };

  loginQueryPage = (): Observable<loginQueryParam> =>
    new ApiBuilder<undefined, loginQueryParam>(this.http, this.appConfig)
      .app('LOGIN_MODAL')
      .endpointKey(LoginModalEndpointsKeys['LOGIN_QUERY_PAGE_BFF_URL'])
      .method(HttpRequestMethods['GET'])
      .errorHandler(this.errorHandler)
      .library('LOGIN_DASHBOARD_SERVICE')
      .create();

  custLogin = (
    payload: loginCustomerRequest
  ): Observable<loginCustomerResponse> =>
    new ApiBuilder<loginCustomerRequest, loginCustomerResponse>(
      this.http,
      this.appConfig
    )
      .app('LOGIN_MODAL')
      .endpointKey(LoginModalEndpointsKeys['LOGIN_CUST_BFF_LOGIN_URL'])
      .method(HttpRequestMethods['POST'])
      .payload(payload)
      .errorHandler(this.errorHandler)
      .library('LOGIN_DASHBOARD_SERVICE')
      .create();
}
